export default theme => ({
  title: {
    fontSize: theme.textSizes[5],
    fontWeight: 500,
    marginBottom: theme.sizes[1],
  },
  subtitle: {
    textTransform: "uppercase",
    fontSize: theme.textSizes[0],
    fontWeight: 500,
    marginBottom: theme.sizes[4],
    color: theme.palette.disabled.main,
  },
  role: {
    marginTop: theme.sizes[1],
    marginRight: theme.sizes[3],
  },
  data: {
    marginTop: theme.sizes[1],
  },
});
